export enum ConditionType {
	QuestionResponse = 1,
	CustomerAttribute = 2,
	CustomerCulture = 3,
	CustomerEventAssignment = 4,
	AlternateContent = 5,
}
